import type { Config, Dict } from 'mixpanel-browser/src/loaders/loader-module-core';
import mixpanel from 'mixpanel-browser/src/loaders/loader-module-core';

// O Bitrix24 abre o placement por POST convertido em GET: a query string e o referrer carregam
// dados do portal do cliente, então nenhuma propriedade de URL pode sair do navegador.
const URL_PROPERTIES = [
	'$current_url',
	'$referrer',
	'$initial_referrer',
	'$referring_domain',
	'$initial_referring_domain',
];

// O `property_blacklist` só filtra eventos. Mesmo com `save_referrer: false`, o perfil ainda pode
// receber o referrer gravado no localStorage antes da configuração, então o perfil passa pelo mesmo
// filtro; o `$set_once` que fica vazio é descartado.
function stripUrlProperties(request: Dict) {
	[request.$set, request.$set_once].forEach((properties: Dict | undefined) => {
		URL_PROPERTIES.forEach((property) => delete properties?.[property]);
	});

	const isEmptySetOnce = request.$set_once && Object.keys(request.$set_once).length === 0;
	return isEmptySetOnce ? null : request;
}

// O SDK chama `before_send_<tipo da requisição>`, mas os tipos dele só declaram o de eventos.
type Hooks = Config['hooks'] & { before_send_people: (request: Dict) => Dict | null };

const hooks: Hooks = { before_send_people: stripUrlProperties };

let initialized = false;

export function initMixpanel() {
	const token = process.env.REACT_APP_MIXPANEL_TOKEN;
	if (initialized || !token) return;

	try {
		mixpanel.init(token, {
			debug: process.env.NODE_ENV === 'development',
			persistence: 'localStorage',
			autocapture: false,
			track_pageview: false,
			record_sessions_percent: 0,
			save_referrer: false,
			property_blacklist: URL_PROPERTIES,
			hooks,
		});
		initialized = true;
	} catch {
		initialized = false;
	}
}

export function isMixpanelReady() {
	return initialized;
}

export function trackPageView(pageName: string) {
	if (!initialized) return;

	mixpanel.track('Page Viewed', { page_name: pageName });
}

type IdentifiedUser = {
	distinctId: string;
	email: string;
	domain: string;
};

// Decisão PC1: identificador da conta + e-mail e domínio do portal como perfil, nada além disso.
export function identifyUser({ distinctId, email, domain }: IdentifiedUser) {
	if (!initialized) return;

	mixpanel.identify(distinctId);
	mixpanel.people.set({ $email: email, domain });
}
